import React, { Component } from 'react';
import ProductsList from '../ProductsList';
import CategoryList from '../CategoryList';
import { withRouter } from 'react-router'
import URI, { IMG_DEV_URL} from '../../constants/serverUrl';
import HeaderSmall from '../HeaderSmall/HeaderSmall';
import { search } from 'superagent';
//const URI = 'http://localhost:8000';

class Products extends Component {

  state = {
    category: null,
    market: null,
    search: null
  }

  categoryMenuColor = (c) => {
    let category_menu_color = '#00c7c5';
    if (c && c.menu_color && c.menu_color != '#000000' && c.menu_color != '#000') {
      category_menu_color = c.menu_color;
    }
    return category_menu_color;
  }

  onCategoryClick = (c) => {
    this.setState({category: c });
  }

  onMarketClick = (c) => {
    this.setState({market: c });
  }

  componentDidMount() {
  }

  handleSearch = (e) => {
    const search = e.target.value;
    this.setState({search});
  }

  render() {
    if(this.props.products.length === 0) {
      return <div style={{height: '1000px'}} />
    }
    const { markets, categories, subCategory_id } = this.props;
    let category = this.state.category || categories.find(c => c.id == this.props.category);
    let market = null;
    let products = [...this.props.products];
    let subCategories = [...categories.filter(c => c.isSubCategory)];

    if(category) {
      products = this.props.products.filter(p => p.productCategory.find(e => e == category.id));
      subCategories = subCategories.filter(sc => sc.relatedCategory.indexOf(category.id) !== -1);
      subCategories.forEach(sc => {
        const prods = this.props.products.filter(p => p.subCategory.find(e => e == sc.id));
        prods.forEach(p => {
          if(!products.find(pp => pp.id === p.id)){
            products.push(p);
          }
        })
      })
    } else if (this.props.market) {
      market = markets.find(c => c.id == this.props.market);
      products = market ? this.props.products.filter(p => !!p.markets.find(m => m == this.props.market)) : this.props.products;
    }


    if(subCategory_id) {
      const subCategory = categories.find(c => c.id == subCategory_id);
      products = this.props.products.filter(
        p => !!( p.productCategory.indexOf(parseInt(subCategory_id)) !== -1) || p.subCategory.indexOf(parseInt(subCategory_id)) !== -1);
    }

    const categoryDesc = category && (category.description && category.description.length > 2) ? category.description : null;
    let name = market ? market.name : 'All Products';
    name = category ? category.name : name;
    let img = null;
    
    const first2ProductImages = categoryDesc && categoryDesc.length > 1 ? products.slice(0, 2).map(p => p.primaryImageLink) : [];
    if(this.state.search && this.state.search.length > 0) {
      products = products.filter(p => {
        const searchLower = this.state.search.toLowerCase();
        return JSON.stringify(p).toLowerCase().includes(searchLower);
      });
    }
    return (
      <div>
        <HeaderSmall title={name} />
        <div className="container p-0">
          <div className="row" style={{backgroundColor: '#FFF', paddingTop: '15px', paddingBottom: '70px'}}>
            <div className="col-3 d-none d-sm-block" style={{ width: '300px'}}>
              { !!categories.length && <CategoryList category={this.state.category || this.props.category} subCategories={subCategories} subCategory={subCategory_id} categories={categories} onCategoryClick={this.onCategoryClick} history={this.props.history} />}
              { !categories.length && <CategoryList category={this.state.market || this.props.market} subCategories={subCategories} categories={markets} onCategoryClick={this.onMarketClick} history={this.props.history} market />}
            </div>
            <div className="col-12 col-sm-9">
              <div className="row" style={{minHeight: '215px', paddingTop: '35px'}}>
                <div className="col-md-6 col-xs-12 px-4 px-sm-0">
                  <span className="heading products-heading">{ name || 'All Products' }</span>
                </div>
                <div className='col-md-6 col-xs-12 d-flex justify-content-end align-items-center'>
                    <input type="text"
                      className="form-control rounded-pill search-input"
                      placeholder="Search for name, brand or use"
                      onChange={this.handleSearch}
                    />
                </div>
                { categoryDesc && <div className="col-12 col-sm-8 px-4 px-sm-0">
                  <span className="description-text" style={{padding: '4px 0px 10px 0px', display: 'inline-block', paddingRight: '9px'}}>
                    { categoryDesc }
                  </span>
                </div> }
                { categoryDesc && <div className="col-4 d-none d-sm-block">
                </div> }
                <div className="col-12 d-none d-sm-block">
                  <span className="roman-smaller grey-text-light" style={{fontSize: '14px', textAlign: 'left'}}>
                    { products.length + ' products'}
                  </span>
                </div>
              </div>

              <ProductsList category={this.state.category || this.props.category} subCategory={categories.find(c => c.id == subCategory_id)} products={products} market={this.props.market} />

              <div className="row d-none d-sm-block">
                <div className="col-md-12" style={{ textAlign: 'right'}}>
                  <div style={{backgroundColor: '#0275d8', height: '1px', width: '100%', marginTop: '30px'}} />
                  <div style={{marginTop: '9px'}}>
                    <span className="roman-smaller grey-text-light">
                      { products.length + ' products'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default withRouter(Products);



// WEBPACK FOOTER //
// src/components/pages/Products.js